(function ($, Drupal, drupalSettings, once) {
  Drupal.behaviors.paragraphFaq = {
    attach: function (context, settings) {
      once("paragraphFaq", ".paragraph--faq", context).forEach(function (element) {
        $(".itemAccordion label").on("click", function () {
          $(this).parent().toggleClass("open");
          if ($(this).parent().hasClass("open")) {
            var hBlock = $(this).parent().find(".itemAccordionContent .inner").outerHeight();
            $(this).parent().find(".itemAccordionContent").css("max-height", hBlock);
          } else {
            $(this).parent().find(".itemAccordionContent").css("max-height", "0");
          }
        });
      });
    },
  };
})(jQuery, Drupal, drupalSettings, once);
